import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import Shop from "@/components/Shop";
import Product from "@/components/Product";
import Blog from "@/components/Blog";
import Post from "@/components/Post";
import Cart from "@/components/Cart";
import Layout from "@/components/Layout";
import Categories from "@/components/Categories";
import MyShop from "@/components/My-Shop"
import Profile from "@/components/Profile"
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "/",
          component: Shop,
          name: "Shop"
        },
        {
          path: "/shop",
          component: Shop,
          name: "Shop"
        },
        {
          path: "/Profile",
          component: Profile,
          name: "Profile"
        }
        ,
        {
          path: "/My-Shop/:productId",
          component: MyShop,
          name: "My-Shop"
        },

        /*
        {
          path:'/product',
          component:Product,
          name:'Product'
        },
        */
        {
          path: "/product/:productId",
          name: "Product",
          component: Product
        },
        {
          path: "/Categories/:categoryName",
          name: "Categories",
          component: Categories
        },

        {
          path: "/blog",
          component: Blog,
          name: "Blog"
        },
        {
          path: "/post",
          component: Post,
          name: "Post"
        },
        {
          path: "/cart",
          component: Cart,
          name: "Cart"
        }
      ]
    }
  ],
  mode: "history"
});



// WEBPACK FOOTER //
// ./src/router/index.js